import * as types from '../../_actions/actionTypes'
import _ from 'lodash'

export function colors(state = { loading: true }, action) {
    switch (action.type) {
        case types.FETCH_COLORS:
            return {
                ...state,
                ...action.payload,
                loading: false,
            }
        case types.FETCH_COLORS_FAILURE:
            return state
        case types.UPDATE_COLORS:
            return _.merge({}, state, action.payload)
        case types.UPDATE_COLORS_FAILURE:
            return state
        case types.REMOVE_COLOR:
            return { colors: _.omit(state.colors, action.payload) }
        case types.REMOVE_COLOR_FAILURE:
            return state
        case types.REMOVE_COLORS:
            const data = _.map(action.payload.colors, d => d.id)
            return { colors: _.omit(state.colors, data) }
        case types.REMOVE_COLORS_FAILURE:
            return state
        default:
            return state
    }
}
